import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";
import BackToApplication from "../general/BackToApplication";
import { TwoHeading } from "../general/TwoHeading";
import { makeStyles } from "@material-ui/core/styles";
import ActionButton from "./ActionButton";
import {
  getInsurerOrderRemaining,
  getIRS,
  getIRSAPP,
  getShowingSendToInsurers,
  getSTCoptions,
  quoteyScoreRecalculateDecider,
  getApiQuoteCount,
  udpateQuoteyScoreInStore,
  initiateInsurerOrderRemaining,
  updateQuoteyScoreInStoreAndDB,
  getIncludanceAll,
  updateSTCOptions,
  updateSTCOptionsToDB,
  reassignRepsonseOrder,
  getProespectInformation
} from "../store/quotes";
import ResultTableHeader from "../general/ResultTableHeader";
import ResponseRow from "../general/ResponseRow";
import { useDispatch, useSelector } from "react-redux";
import {
  changeScrollDivResponse,
  getScrollResponsesDiv,
  getProspectid,
  getInsurerOrder,
  getResponseDetails,
} from "../store/quotes";
import * as theme from "../theme";
import StiTableHeader from "./StiTableHeader";
import InsurerRow from "./InsurerRow";
import LinkSelect from "./LinkSelect";
import {
  getDefaultSelectedOption,
  EMPTY_COVER_ROW_DETAILS,
} from "../store/businesslogic/hardwiredlogic";
import { useNavigate, useLocation } from "react-router-dom";
import {
  getQuotes,
  getMyQuotes,
  getGettingMyQuotesSuccess,
} from "../store/myquotes";
import { getBindExternal } from "../store/components";
import { EXTERNALBINDMSG } from "../helper/constants";
import { getLanguagePreference, getBrokerInformation } from "../store/broker";
import externalTranslations from "../utils/translations";
import { getIsBpSuccess, updateBmsInfo, updateProspectStatus } from "../store/qf";
const useStyles = makeStyles(theme.customMaterialUIClassForScrollBar);

const LeftPaneQuoteResults = (props) => {
  const isMounted = useRef(false);
  const isAscMounted = useRef(true);
  const isDescMounted = useRef(false);
  const dispatch = useDispatch();
  const responsesDiv = useRef(null);
  const showingSendToInsurers = useSelector(getShowingSendToInsurers);
  const [clientName, setclientName] = useState(null);
  const responseorder = useSelector(
    (state) => state.entities.quotes.responseorder
  );
  const gettingMyQuotesSucceed = useSelector(getGettingMyQuotesSuccess);
  const Prospectid = useSelector(getProspectid);
  const brokerage = useSelector(getBrokerInformation);
  const languagepreference = brokerage.information.languagepreference;
  const Quotes = useSelector(getQuotes);
  const prospectInformation = useSelector(getProespectInformation);
  const translations = {
    en: {
      backToDigitalMarketing: "Back to Digital Marketing",
      backToApplication: "Back to Application",
      sendToInsurers: "Send To Insurers",
      insurersMatch:
        "These insurers are recommended as a potential match for your client.",
      digitalMarketingHub: "Digital Marketing Hub",
      for: "for",
      digitalHubDescription:
        "In the digital marketing hub you'll automatically see responses from participating insurers, and can also track responses from other markets.",

      insurer: "Insurer",
      product: "Product",
      recommendedscore: "Quotey Score",
      price: "Price",
      coveragelevel: "Coverage Level",
      rateit: "Give a Rating",
      type: "Type",

      contact: "Contact",

      externalLink: {
        text: "Create and copy a link that you can send to insurers which provides them with a non-editable view of the client’s application in Quotey",
        buttonText: "Get external link to Quotey screens",
      },
      sendToSelectedInsurers: "Send to selected insurers",
      createEmailWithApplication: "Create email with application",
      downloadPDF: {
        text: "Download a PDF containing all the application questions and answers",
        buttonText: "Download application PDF",
      },
      editPDFOptions: "Edit PDF Options",
      downloadPDFButtonText: "Download PDF",
    },
    fr: {
      backToDigitalMarketing: "Retour aux Assurers",
      backToApplication: "Retour à la proposition d'assurance",
      sendToInsurers: "Envoyer aux Assureurs",
      insurersMatch:
        "Ces assureurs sont recommandés comme correspondance potentielle pour votre client.",
      digitalMarketingHub: "Plate-forme numérique",
      for: "pour",
      digitalHubDescription:
        "Dans le centre de marketing numérique, vous verrez automatiquement les réponses des assureurs participants et pourrez également suivre les réponses d'autres marchés.",

      insurer: "Assureur",
      product: "Produit",
      recommendedscore: "Score Quotey",
      price: "Prix",
      coveragelevel: "Pourcentage de couverture",
      rateit: "Donner une note",
      type: "Type",

      contact: "Contact",

      externalLink: {
        text: "Créez et copiez un lien que vous pouvez envoyer aux assureurs, leur offrant une vue non modifiable de la demande du client dans Quotey",
        buttonText: "Obtenir le lien externe vers les écrans Quotey",
      },
      sendToSelectedInsurers: "Envoyer aux assureurs sélectionnés",
      createEmailWithApplication: "Créer un email avec la demande",
      downloadPDF: {
        text: "Télécharger un PDF contenant toutes les questions et réponses de la proposition d'assurance",
        buttonText: "PDF de la proposition d'assurance",
      },
      editPDFOptions: "Modifier les options PDF",
      downloadPDFButtonText: "Télécharger le PDF",
    },
  };

  useEffect(() => {
    dispatch(getMyQuotes(null));
  }, []);
  useEffect(() => {
    if (gettingMyQuotesSucceed) {
      let ProspectDetails_ = Quotes?.table[Prospectid];
      //console.log("ProspectDetails_: ", ProspectDetails_)
      if (
        ProspectDetails_?.CLIENT_NAME &&
        ProspectDetails_.CLIENT_NAME.trim() != "" &&
        !showingSendToInsurers
      ) {
        setclientName(
          ` ${languagepreference === "fr" ? translations.fr.for : translations.en.for} ${
            ProspectDetails_?.CLIENT_NAME
          }`
        );
      }
    }
  }, [Quotes, languagepreference]);
  const responsedetails = useSelector(
    (state) => state.entities.quotes.responsedetails
  );
  let price_array = [];
  for (let key in responsedetails) {
    let coverageLvl = responsedetails[key].covers?.[5];
    if (["", null].includes(coverageLvl)) {
      coverageLvl = undefined;
    }
    price_array.push({
      responseId: key,
      price: responsedetails[key].covers?.[3],
      name: responsedetails[key].insurercode,
      score: responsedetails[key].quoteyscore || undefined,
      coveragelevel: coverageLvl,
    });
  }
  const insurerorder = useSelector(getInsurerOrder);
  const insurerorderRemaining = useSelector(getInsurerOrderRemaining);

  const isScrollResponsesDiv = useSelector(getScrollResponsesDiv);
  const irs = useSelector(getIRS);
  const irsapp = useSelector(getIRSAPP);
  const leftRightMargin = "5vw";
  const mainContMargin = "5vw";
  const HeadingText1 = showingSendToInsurers
    ? languagepreference === "fr"
      ? translations.fr.sendToInsurers
      : translations.en.sendToInsurers
    : languagepreference === "fr"
    ? translations.fr.digitalMarketingHub
    : translations.en.digitalMarketingHub;

  const HeadingText2 = showingSendToInsurers
    ? languagepreference === "fr"
      ? translations.fr.insurersMatch
      : translations.en.insurersMatch
    : languagepreference === "fr"
    ? translations.fr.digitalHubDescription
    : translations.en.digitalHubDescription;


  let heightDivison = {
    backtoapp: "9%",
    quoteresults: "11%",
    tableheader: "60px",
    bottommargin: "5px",
    spaceBetweenHeaderContent: showingSendToInsurers ? "0px" : "12px",
    responses: "",
  };

  heightDivison.responses = `calc(100% - ${heightDivison.backtoapp} - ${heightDivison.quoteresults} - ${heightDivison.tableheader} - ${heightDivison.bottommargin} - ${heightDivison.spaceBetweenHeaderContent})`;

  const classes = useStyles();

  const getDefaultSTCOptions = () => ({
    aboutus: { selected: false },
    meetyourteam: { selected: false },
    comments: { selected: false },
    reviewsign: { selected: false },
    listinsurers: {
      selected: false,
      insurerselected: getDefaultSelectedOption(languagepreference),
    },
    comparison: { selected: false },
    rawQuoteInformation: { selected: false },
    covers: {
      selected: false,
      table: {
        order: [0],
        details: { 0: EMPTY_COVER_ROW_DETAILS },
      },
    },
  });

  // const columnHeadingsQuotes = {
  //   toggle: "",
  //   insurer: "Insurer",
  //   product: "Product",
  //   recommendedscore: "Quotey Score",
  //   price: "Price",
  //   coveragelevel: "Coverage Level",
  //   rateit: "Give a Rating",
  //   type: "Type",
  // };
  // const translations = {
  //   en: {
  //     insurer: "Insurer",
  //     product: "Product",
  //     recommendedscore: "Quotey Score",
  //     price: "Price",
  //     coveragelevel: "Coverage Level",
  //     rateit: "Give a Rating",
  //     type: "Type",
  //   },
  //   fr: {
  //     insurer: "Assureur",
  //     product: "Produit",
  //     recommendedscore: "Score Quotey",
  //     price: "Prix",
  //     coveragelevel: "Niveau de couverture",
  //     rateit: "Donner une note",
  //     type: "Type",
  //   },
  // };

  const columnHeadingsQuotes = {
    toggle: "",
    insurer: translations[languagepreference].insurer,
    product: translations[languagepreference].product,
    recommendedscore: translations[languagepreference].recommendedscore,
    price: translations[languagepreference].price,
    coveragelevel: translations[languagepreference].coveragelevel,
    rateit: translations[languagepreference].rateit,
    type: translations[languagepreference].type,
  };
  const ColoumnWidth = {
    toggle: "6.3%",
    insurer: "16%",
    product: "19%",
    recommendedscore: "15%",
    price: "9%",
    type: "5%",
    coveragelevel: "",
    rateit: "15%",
  };

  ColoumnWidth.coveragelevel = `calc(100% - ${ColoumnWidth.toggle} - ${ColoumnWidth.insurer} - ${ColoumnWidth.product} - ${ColoumnWidth.recommendedscore} - ${ColoumnWidth.price} - ${ColoumnWidth.type} - ${ColoumnWidth.rateit})`;

  const CommonStyleColumn = {
    color: "white",
    fontFamily: "GibsonRegular",
    alignSelf: "center",
    borderRight: "1px solid white",
    height: "100%",
    display: "flex",
    alignItems: "center",
    letterSpacing: 1,
    justifyContent: "center",
    textAlign: "center",
  };

  const BorderRaidus = 8;

  const headingStyle = {
    height: showingSendToInsurers ? "77%" : "75%",
    width: "100%",
    backgroundColor: theme.COLORS.secondary_skyblue,
    borderTopLeftRadius: BorderRaidus,
    borderTopRightRadius: BorderRaidus,
    display: "flex",
    flexDirection: "row",
  };

  const stiColoumnWidth = {
    first: "17%",
    second: "23%",
    third: "",
    fourth: "20%",
    fifth: "12%",
  };

  stiColoumnWidth.third = `calc(100% - ${stiColoumnWidth.first} - ${stiColoumnWidth.second} - ${stiColoumnWidth.fourth} - ${stiColoumnWidth.fifth})`;

  const sticolumnHeadingsQuotes = {
    first: "",
    second: translations[languagepreference]?.insurer,
    third: translations[languagepreference]?.contact,
    fourth: translations[languagepreference]?.recommendedscore,
  };
  const dynamicSort = (property) => {
    var sortOrder = 1;
    if (property[0] === "-") {
      sortOrder = -1;
      property = property.substr(1);
    }
    return function (a, b) {
      /* next line works with strings and numbers,
       * and you may want to customize it to your needs
       */
      var result =
        a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
      return result * sortOrder;
    };
  };

  useLayoutEffect(() => {
    let { scrollHeight, clientHeight } = responsesDiv.current;

    if (scrollHeight > clientHeight) {
      dispatch(changeScrollDivResponse(true));
    } else {
      dispatch(changeScrollDivResponse(false));
    }
  });
  const { search } = useLocation();
  const prospectid = search.substring(4);
  const stcoptions = useSelector(getSTCoptions);
  const navigate = useNavigate();
  const bindExternal = useSelector(getBindExternal);
  const isBpSuccess = useSelector(getIsBpSuccess);
  const warningString = bindExternal == "loading" ? EXTERNALBINDMSG : "";
  const direction = (dirc, col) => {
    if (!dirc) {
      return;
    }
    if (dirc == "asc" && !isAscMounted.current) {
      isDescMounted.current = false;
      isAscMounted.current = true;
    } else if (dirc == "desc" && !isDescMounted.current) {
      isDescMounted.current = true;
      isAscMounted.current = false;
    }
    let priceAscOrDesc: any;
    // if (!isDescMounted.current && dirc == "asc" && col == "price") {
    //   priceAscOrDesc = price_array
    //     .sort(dynamicSort("price"))
    //     .map((x) => x?.responseId);
    //   dispatch(reassignRepsonseOrder(priceAscOrDesc));
    // } else if (!isAscMounted.current && dirc == "desc" && col == "price") {
    //   priceAscOrDesc = price_array
    //     .sort(dynamicSort("-price"))
    //     .map((x) => x?.responseId);
    //   dispatch(reassignRepsonseOrder(priceAscOrDesc));
    var dynamicString = col;
    if (dirc == "desc") {
      dynamicString = "-" + dynamicString;
    }
    priceAscOrDesc = price_array
      .sort(dynamicSort(dynamicString))
      .map((x) => x?.responseId);
    dispatch(reassignRepsonseOrder(priceAscOrDesc));
    return;
  };
  const lastUpdate = useRef(0);
  useEffect(() => {
    isMounted.current = true;
    // update to db
    if (isMounted.current) {
      dispatch(updateSTCOptionsToDB({ prospectid, stcoptions }));
      if (Date.now() - lastUpdate.current > 1000) {
        dispatch(updateSTCOptionsToDB({ prospectid, stcoptions }));
      }
      lastUpdate.current = Date.now();
    }
  }, [stcoptions]);

  useEffect(() => {
    //if(isBpSuccess){
    dispatch(updateBmsInfo({ action: "to_market", postdata: { prospectid } }));
    //}
  }, []);

  useEffect(() => {
    if (stcoptions === null) {
      dispatch(updateSTCOptions({ stcoptions: getDefaultSTCOptions() }));
    }
    if (showingSendToInsurers) {
      dispatch(getIncludanceAll({ prospectid }));
    }
  }, []);

  const recalculateQuoteyScore = useSelector(quoteyScoreRecalculateDecider);
  const apiCountCount = useSelector(getApiQuoteCount);
  const responseDetails = useSelector(getResponseDetails);
  useEffect(() => {
    if (recalculateQuoteyScore) {
      dispatch(updateQuoteyScoreInStoreAndDB());
    }
  }, [recalculateQuoteyScore]);

  useEffect(() => {
    let allEResponse = Object.entries(responseDetails).filter(([k, v]) =>
      ["external", "inhouse"].includes(v.source)
    ).length;
    if (
      allEResponse &&
      apiCountCount[0] == allEResponse &&
      apiCountCount[1] == allEResponse
    ) {
      let postdata = Object.entries(responseDetails).map(([k, v]) => {
        return {
          insurercode: v.insurercode,
          premium: v.covers?.[3],
          comment: v.covers?.[2],
        };
      });
      dispatch(updateBmsInfo({ action: "send_quotes", postdata }));
      console.log(postdata)
      if(postdata.some(q => q.premium && Number(q.premium) > 0) ){
        dispatch(updateProspectStatus({prospectid, statuscode:'quote_received'}))
      }
    }
  }, [apiCountCount, responseDetails]);

  const deciderDiv = () => {
    if (showingSendToInsurers) {
      return insurerorder.map((code) => (
        <InsurerRow
          key={code}
          code={code}
          stiColoumnWidth={stiColoumnWidth}
        ></InsurerRow>
      ));
    } else {
      return responseorder.map((responseid, index) => (
        <ResponseRow
          ColoumnWidth={ColoumnWidth}
          key={responseid}
          responseid={responseid}
          prospectid={prospectid}
        ></ResponseRow>
      ));
    }
  };
  const loadSecondTable = () => {
    dispatch(initiateInsurerOrderRemaining());
  };
  return (
    <>
      <div
        style={{
          height: "100%",
          width: "100%",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            height: heightDivison.backtoapp,
            alignItems: "center",
            display: "flex",
            paddingLeft: leftRightMargin,
            paddingRight: leftRightMargin,
            width: "100%",
          }}
        >
          <BackToApplication
            text={
              showingSendToInsurers
                ? translations[languagepreference].backToDigitalMarketing
                : translations[languagepreference].backToApplication
            }
            onClick={() => {
              if (showingSendToInsurers) {
                //navigate(`/quotes?id=${prospectid}`);
                document.location.href = `/quotes?id=${prospectid}`;
              } else {
                //navigate(`/questions?id=${prospectid}`);
                document.location.href = `/questions?id=${prospectid}`;
              }
            }}
          ></BackToApplication>
        </div>
        <div
          style={{
            height: heightDivison.quoteresults,
            width: "100%",
            display: "block",
            paddingLeft: mainContMargin,
            paddingRight: mainContMargin,
          }}
        >
          <div>
            <TwoHeading
              heading1={HeadingText1}
              heading2={HeadingText2}
              subheading1={clientName}
              handleSubHeadingClick={() => {
                if(prospectInformation.customerid) {
                   navigate(`/customer?id=${prospectInformation.customerid}`)
                }
              }}
              warningheader={warningString}
            ></TwoHeading>
          </div>
        </div>
        <div
          style={{
            height: heightDivison.tableheader,
            width: "100%",
            paddingLeft: mainContMargin,
            paddingRight: mainContMargin,
            display: "flex",
            alignItems: "flex-end",
          }}
        >
          {showingSendToInsurers ? (
            <StiTableHeader
              stiColoumnWidth={stiColoumnWidth}
              sticolumnHeadingsQuotes={sticolumnHeadingsQuotes}
              CommonStyleColumn={CommonStyleColumn}
              headingStyle={headingStyle}
            ></StiTableHeader>
          ) : (
            <ResultTableHeader
              ColoumnWidth={ColoumnWidth}
              columnHeadingsQuotes={columnHeadingsQuotes}
              CommonStyleColumn={CommonStyleColumn}
              headingStyle={headingStyle}
              direction={direction}
            ></ResultTableHeader>
          )}
        </div>
        <div style={{ height: heightDivison.spaceBetweenHeaderContent }}></div>

        <div
          style={{
            width: "100%",
            height: heightDivison.responses,
            paddingLeft: mainContMargin,
            paddingRight: isScrollResponsesDiv
              ? `calc(${mainContMargin} - ${theme.SCALES.scrollbarThickness} - ${theme.SCALES.responsesSpacesBetweenScroll})`
              : mainContMargin,
          }}
        >
          <div
            className={classes.responses}
            style={{
              width: "100%",
              paddingRight: isScrollResponsesDiv
                ? theme.SCALES.responsesSpacesBetweenScroll
                : "0px",
              height: showingSendToInsurers
                ? insurerorder.length < 6
                  ? insurerorder.length * 13.67 + "%"
                  : "100%"
                : "100%",
              overflow: "auto",
            }}
            ref={responsesDiv}
          >
            {deciderDiv()}
          </div>

          {/* this section is to show the remaining insurers */}

          {showingSendToInsurers ? (
            <>
              <div style={{ height: "5%" }} />
              <TwoHeading
                heading1={
                  externalTranslations[languagepreference].otherInsurers
                    .heading1
                }
                heading2={
                  externalTranslations[languagepreference].otherInsurers
                    .heading2
                }
                fontSize="2vmin"
              ></TwoHeading>
              {insurerorderRemaining.length ? null : (
                <ActionButton
                  style={{ width: "auto", float: "right", height: "auto" }}
                  text={
                    externalTranslations[languagepreference].otherInsurers
                      .seeAllInsurers
                  }
                  onClick={loadSecondTable}
                ></ActionButton>
              )}

              {insurerorderRemaining.length ? (
                <div
                  style={{
                    height: heightDivison.tableheader,
                    width: "100%",
                    // paddingLeft: mainContMargin,
                    // paddingRight: mainContMargin,
                    display: "flex",
                    alignItems: "flex-end",
                  }}
                >
                  <StiTableHeader
                    stiColoumnWidth={stiColoumnWidth}
                    sticolumnHeadingsQuotes={sticolumnHeadingsQuotes}
                    CommonStyleColumn={CommonStyleColumn}
                    headingStyle={headingStyle}
                  ></StiTableHeader>
                </div>
              ) : (
                <div style={{ height: "4vh" }}></div>
              )}

              <div
                style={{ height: heightDivison.spaceBetweenHeaderContent }}
              ></div>
              <div
                className={classes.responses}
                style={{
                  width: "100%",
                  paddingRight: isScrollResponsesDiv
                    ? theme.SCALES.responsesSpacesBetweenScroll
                    : "0px",
                  height: insurerorderRemaining
                    ? insurerorderRemaining?.length < 6
                      ? insurerorderRemaining?.length * 13.67 + "%"
                      : "100%"
                    : 0,
                  overflow: "auto",
                }}
                ref={responsesDiv}
              >
                {insurerorderRemaining?.map((code) => (
                  <InsurerRow
                    key={code}
                    code={code}
                    stiColoumnWidth={stiColoumnWidth}
                  ></InsurerRow>
                ))}
              </div>
              <div style={{ height: "3vh" }}></div>
            </>
          ) : null}
        </div>

        <div style={{ height: heightDivison.bottommargin }}></div>
      </div>
    </>
  );
};

export default LeftPaneQuoteResults;
